export default __webpack_public_path__ + "static/media/expand_more-white.c20ca823.svg";